import { useState } from 'react';
import { EmailTypeClient, EmailTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useEmailTypeApi = () => {
    const apiClient = new EmailTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: EmailTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createEmailType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating EmailType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: EmailTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateEmailType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating EmailType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getEmailTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching EmailType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchEmailTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching EmailTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteEmailType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting EmailType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};